import React, { useState, useEffect } from "react";
import { Box, Button, Spinner, useMediaQuery } from "@chakra-ui/react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useToast,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";

import LACTableauChannel from "../../../Components/EmbedLAC/LACTableauChannel";
import LACTableauDSR from "../../../Components/EmbedLAC/LACTableauDSR";
import LACTableauHourly from "../../../Components/EmbedLAC/LACTableauHourly";
import LACTableauMIX from "../../../Components/EmbedLAC/LACTableauMIX";
import LACTableauNPS from "../../../Components/EmbedLAC/LACTableauNPS";
import LACTableauTender from "../../../Components/EmbedLAC/LACTableauTender";
import LACTableauWeekly from "../../../Components/EmbedLAC/LACTableauWeekly";

import LACTableauChannelM from "../../../Components/EmbedLAC/MobileView/LACTableauChannelM";
import LACTableauDSRM from "../../../Components/EmbedLAC/MobileView/LACTableauDSRM";
import LACTableauHourlyM from "../../../Components/EmbedLAC/MobileView/LACTableauHourlyM";
import LACTableauMIXM from "../../../Components/EmbedLAC/MobileView/LACTableauMIXM";
import LACTableauNPSM from "../../../Components/EmbedLAC/MobileView/LACTableauNPSM";
import LACTableauTenderM from "../../../Components/EmbedLAC/MobileView/LACTableauTenderM";
import LACTableauWeeklyM from "../../../Components/EmbedLAC/MobileView/LACTableauWeeklyM";

import axios from "axios";

const ReportsLAC = () => {
  const [isSmallerThan600] = useMediaQuery("(max-width: 600px)");
  const [refreshPage, setRefreshPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [key, setKey] = useState(Date.now());
  const toast = useToast();

  const handleRefreshTokenTableauButton = async () => {
    try {
      setLoading(true);
      const resJWTTableau = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
        { withCredentials: true }
      );
      localStorage.setItem("tableauToken", resJWTTableau.data);
      setRefreshPage((prev) => !prev);
      setKey(Date.now());
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast({
        title: "Error",
        position: "top-right",
        description: err.response.data.message,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFirstLoad(false);
    }, 1000 * 3); // 10 seconds

    return () => clearTimeout(timer);
  }, [refreshPage]);

  return (
    <div>
      <div key={key}>
        <Box mt={4} mb={2}>
          <Button
            colorScheme="red"
            onClick={handleRefreshTokenTableauButton}
            isDisabled={loading}
          >
            {loading ? (
              <Spinner />
            ) : (
              <>
                Refresh <RepeatIcon marginLeft={2} />
              </>
            )}
          </Button>
        </Box>
        <Tabs isFitted variant="enclosed">
          <TabList
            mb="1em"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Tab _selected={{ color: "white", bg: "red.500" }}>Product Mix</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>Hourly</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>Weekly</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>Tender</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>Channel</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>DSR</Tab>
            <Tab _selected={{ color: "white", bg: "red.500" }}>NPS</Tab>
          </TabList>
          <TabPanels
            height={{
              base: "100%", // 0-48em
              md: "50%", // 48em-80em,
              xl: "25%", // 80em+
            }}
            width="100%"
            m={0}
            p={0}
          >
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauMIXM />
              ) : (
                <LACTableauMIX />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauHourlyM />
              ) : (
                <LACTableauHourly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauWeeklyM />
              ) : (
                <LACTableauWeekly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauTenderM />
              ) : (
                <LACTableauTender />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauChannelM />
              ) : (
                <LACTableauChannel />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauDSRM />
              ) : (
                <LACTableauDSR />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <LACTableauNPSM />
              ) : (
                <LACTableauNPS />
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
};

export default ReportsLAC;
